var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { formatDate, getLocale, toDate, setLocale } from '@project/utils/date';
import { faCalendarDay } from '@fortawesome/pro-regular-svg-icons/faCalendarDay';
import Popover from '@project/components/Popover';
import { popoverContainer, valueContainer } from './styles';
import { DatePickerInput } from '../index';
import { tagDefine } from '../../../TagContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import './datepicker.css';
var Picker = function (_a) {
    var 
    // defaults
    date = _a.date, _b = _a.dateFormat, dateFormat = _b === void 0 ? 'yyyy-MM-dd HH:mm' : _b, _c = _a.showTimeSelect, showTimeSelect = _c === void 0 ? true : _c, _d = _a.timeFormat, timeFormat = _d === void 0 ? 'HH:mm' : _d, _e = _a.timeIntervals, timeIntervals = _e === void 0 ? 1 : _e, _f = _a.yearDropdownItemNumber, yearDropdownItemNumber = _f === void 0 ? 100 : _f, _g = _a.dropdownMode, dropdownMode = _g === void 0 ? 'scroll' : _g, autoWidth = _a.autoWidth, _h = _a.disabled, disabled = _h === void 0 ? false : _h, onChange = _a.onChange, minDate = _a.minDate, _j = _a.isMandatory, isMandatory = _j === void 0 ? false : _j, props = __rest(_a, ["date", "dateFormat", "showTimeSelect", "timeFormat", "timeIntervals", "yearDropdownItemNumber", "dropdownMode", "autoWidth", "disabled", "onChange", "minDate", "isMandatory"]);
    useEffect(function () {
        setLocale(registerLocale);
    }, []);
    var _k = useState(false), isOpen = _k[0], setIsOpen = _k[1];
    var formattedDate = (date && formatDate(date)) || (_jsx(_Fragment, { children: tagDefine('Null', 'input') }));
    return (_jsx("div", __assign({ style: {
            width: autoWidth ? '100%' : '560px',
            cursor: 'pointer',
            marginTop: 4,
            marginBottom: 4,
        } }, { children: _jsx(Popover, __assign({ bodyStyle: popoverContainer, body: _jsx(DatePicker, __assign({ selected: toDate(date), dateFormat: dateFormat, showTimeInput: showTimeSelect, timeFormat: timeFormat, timeIntervals: timeIntervals, showYearDropdown: true, yearDropdownItemNumber: yearDropdownItemNumber, scrollableYearDropdown: true, locale: getLocale().locale, dropdownMode: dropdownMode, onChange: onChange, minDate: minDate || null, inline: true }, props)), isOpen: isOpen, preferPlace: "below", bgColor: "#eee", borderColor: "#ccc", onOuterAction: function () { return setIsOpen(false); } }, { children: _jsx(DatePickerInput, __assign({ style: { width: '100%' }, iconPrefix: faCalendarDay, value: formattedDate, disabled: disabled, onClick: function () {
                    setIsOpen(disabled ? isOpen : !isOpen);
                }, readonly: true }, props, { children: _jsxs("div", __assign({ style: valueContainer }, { children: [formattedDate, !isMandatory && (_jsx(FontAwesomeIcon, { onClick: function () {
                                onChange('');
                            }, icon: faTimes }))] })) })) })) })));
};
export default Picker;
